/* eslint-disable jsx-a11y/alt-text */
import React from "react";

const MuyPronto = () => {
  const logo = require("../../img/logo.png").default;
  const logo2 = require("../../img/logo@2x.png").default;
  const logo3 = require("../../img/logo@3x.png").default;

  return (
    <div className="muy-pronto">
      <div className="muy-pronto-content">
        <img
          className="muy-pronto-logo"
          src={logo}
          srcSet={`${logo2} 2x, ${logo3} 3x`}
          alt="La Pinocha logo"
        />
        <img
          className="muy-pronto-flag"
          src={require("../../img/uy-flag.png").default}
          alt="Uruguay"
        />
        <span className="muy-pronto-title">Muy pronto</span>
        <span className="muy-pronto-subtitle">
          Estamos preparando algo especial para Uruguay.
        </span>
        <a href="/" className="muy-pronto-back">
          Volver a la selección de países
        </a>
      </div>
    </div>
  );
};

export default MuyPronto;
